<template>
  <div
    id="mapContainer"
    class="baseMap"
  />
</template>

<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('map')

export default {
  props: {
    accessToken: { type: String, default: null },
    mapStyle: { type: String, default: null },
    mapLayer: { type: String, default: null },
    centerPoint: { type: Array, default: () => [] },
    zoomLevel: { type: Number, default: null },
    minZoom: { type: Number, default: null },
    maxZoom: { type: Number, default: null },
  },
  computed: {
    ...mapState(['popupTitle']),
  },
  watch: {
    popupTitle(newPopupTitle) {
      this.addPopup(newPopupTitle)
    },
  },
  mounted() {
    this.createMap()
    this.map.on('click', event => {
      let features = this.map.queryRenderedFeatures(event.point, {
        layers: [this.mapLayer],
      })
      if (!features.length) {
        return
      }
      let feature = features[0]
      new mapboxgl.Popup({ offset: [0, -20], closeButton: false })
        .setLngLat(feature.geometry.coordinates)
        .setHTML(
          `<h3>${feature.properties.Title}</h3><p>${
            feature.properties.Description
          }</p><p><a href="https://www.google.com/maps/place/${feature.properties.Address}" target=”_blank”>${
            feature.properties.Address
          }</a></p><p><a href="${
            feature.properties.Instagram
          }" target=”_blank”>${feature.properties.Instagram.replace(
            /https:\/\/www.instagram.com\//gi,
            '@',
          ).replace(/\/+$/, '')}</a></p>`,
        )
        .addTo(this.map)
    })
  },
  methods: {
    createMap() {
      try {
        mapboxgl.accessToken = this.accessToken
        this.map = new mapboxgl.Map({
          container: 'mapContainer',
          style: this.mapStyle,
          center: JSON.parse(this.centerPoint),
          zoom: this.zoomLevel,
          maxZoom: this.maxZoom,
          minZoom: this.minZoom,
        })
      } catch (err) {
        console.log(err)
      }
    },
    addPopup(newPopupTitle) {
      try {
        let element = document.getElementById('mapContainer')
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
        const popups = document.getElementsByClassName('mapboxgl-popup')
        if (popups.length) {
          popups.forEach(popup => {
            popup.remove()
          })
        }
        const featureStore = {
          'Septime La Cave': [2.380209, 48.853721],
          'Maison Suisen': [2.362905, 48.859874],
          'Jaïs': [2.309382, 48.86207],
          'Une Glace à Paris': [2.356333, 48.858119],
          'Cravan': [2.273845, 48.851662],
          'Sushi Masunaga': [139.761674, 35.669073],
          'SG Club': [139.698151, 35.664126],
          'Acid Coffee': [139.6969215, 35.6642658],
          'Pejite': [139.711637, 35.663701],
          'The Bellwood': [139.6949951, 35.6631041],
          'Hoshinoya Hotel': [139.7650363, 35.6877316],
          'Casa Lhasa': [1.476665, 39.034642],
          "S'Illot des Renclí": [1.503147, 39.099627],
          'Terra Masia': [1.495917, 39.002519],
          'Chiringuito': [1.589638, 39.058381],
          'Bar Milagros': [1.426943, 38.998752],
        }
        console.log(`Flying to ${featureStore[newPopupTitle]}`)
        // Find selected feature within visible features
        this.map.flyTo({
          center: featureStore[newPopupTitle],
          zoom: 15,
          speed: 1.4,
          curve: 1.2,
        })
        setTimeout(() => {
          let [selectedFeature] = this.map.queryRenderedFeatures({
            filter: ['==', 'Title', newPopupTitle],
          })
          if (selectedFeature) {
            let tabelogHack = false
            let noInsta = false
            if (selectedFeature.properties.Instagram.includes('tabelog')) {
              tabelogHack = 'tabelog.com'
            }
            if (!selectedFeature.properties.Instagram) {
              noInsta = ''
            }
            // Add new popup for selected feature
            new mapboxgl.Popup({ offset: [0, -20], closeButton: false })
              .setLngLat(selectedFeature.geometry.coordinates)
              .setHTML(
                `<h3>${selectedFeature.properties.Title}</h3><p>${
                  selectedFeature.properties.Description
                }</p><p><a href="https://www.google.com/maps/place/${
                  selectedFeature.properties.Address
                }" target=”_blank”>${selectedFeature.properties.Address}</a></p><p><a href="${
                  selectedFeature.properties.Instagram
                }" target=”_blank”>${
                  tabelogHack ||
                  noInsta ||
                  selectedFeature.properties.Instagram.replace(
                    /https:\/\/www.instagram.com\//gi,
                    '@',
                  ).replace(/\/+$/, '')
                }</a></p>`,
              )
              .addTo(this.map)
          }
        }, 1800)
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style scoped>
.baseMap {
  width: 100%;
  height: 80vh;
}
</style>
